/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_Upload_FailedInputs */



/**
* | output |
* | --- |
* | "Could not read that file as a PowerPoint template." |
*
* @param {Presentation_Template_Master_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_upload_failed = /** @type {((inputs?: Presentation_Template_Master_Upload_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_Upload_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei konnte nicht als PowerPoint-Vorlage gelesen werden.")
	return /** @type {LocalizedString} */ ("Could not read that file as a PowerPoint template.")
});